"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const zod_1 = require("zod");
const writer_schema_1 = __importDefault(require("@Entities/schemas/work/writer-schema"));
const work_schema_1 = __importDefault(require("@Entities/schemas/work/work-schema"));
const existingWorkSchema = work_schema_1.default.extend({
    writers: zod_1.z.array(writer_schema_1.default),
});
exports.default = existingWorkSchema;
